export default "__VITE_ASSET__D2UMC705__"